import { render, staticRenderFns } from "./ImgGoodsSelect.vue?vue&type=template&id=3d293b62&scoped=true&"
import script from "./ImgGoodsSelect.vue?vue&type=script&lang=js&"
export * from "./ImgGoodsSelect.vue?vue&type=script&lang=js&"
import style0 from "./ImgGoodsSelect.vue?vue&type=style&index=0&id=3d293b62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d293b62",
  null
  
)

export default component.exports